import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Loader2, Lock } from 'lucide-react';
import { useCart } from '../lib/cartContext';
import { checkoutApi } from '../lib/api';
import { EmptyCart } from './checkout/EmptyCart';

// Native Shopify checkout: this route hands the cart to Shopify's hosted
// checkout so the order lands in Shopify (notifications, inventory, Redo).
export default function CheckoutPage() {
  const { cart } = useCart();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!cart?.id || !cart.items?.length) return;
    let cancelled = false;
    checkoutApi
      .shopifyCartUrl({ cart_id: cart.id })
      .then(({ data }) => {
        if (cancelled) return;
        if (data?.url) window.location.href = data.url;
        else setError('Could not start checkout. Please try again.');
      })
      .catch((err) => {
        if (!cancelled) setError(err?.response?.data?.detail || 'Could not start checkout. Please try again.');
      });
    return () => { cancelled = true; };
  }, [cart]);

  if (cart && cart.items.length === 0) {
    return <EmptyCart />;
  }

  return (
    <main className="pt-20 min-h-screen" data-testid="checkout-page">
      <div className="container-ninja section-spacing">
        <Link
          to="/shop"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors duration-300 mb-10"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="text-sm uppercase tracking-wider" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
            Back to Shop
          </span>
        </Link>

        <div className="max-w-md mx-auto text-center py-16" data-testid="checkout-redirect">
          {error ? (
            <>
              <p className="text-[#E63946] mb-4" data-testid="checkout-error">{error}</p>
              <Link to="/shop" className="btn-ninja inline-flex">Return to Shop</Link>
            </>
          ) : (
            <>
              <Loader2 className="w-10 h-10 animate-spin text-[#C7FA3E] mx-auto mb-6" />
              <h1 className="text-white text-2xl mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                Taking you to secure checkout
              </h1>
              <p className="text-zinc-400 text-sm flex items-center justify-center gap-1.5">
                <Lock className="w-3.5 h-3.5" /> Payment is processed securely by Shopify
              </p>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
